import { useAtomicReducer } from '@pods-finance/hooks'

export const initial = {
  /** Tokens will be listed here in the object by address-key */
}

export default {
  useReducer: () => useAtomicReducer(initial)
}
